import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';

import StoreName     from '../../../../../State/Shared/Constants/StoreName';
import IPlayerStores from '../../../../../State/Shared/Interfaces/IPlayerStores';
import Volume        from '../../../../../State/Stores/Volume/Volume';

import * as styles from '../../../Styles/svgShadow.css';

class IconVolume extends React.Component<IConnectProps<Volume, IPlayerStores>> {
    public shouldComponentUpdate(nextProps: IConnectProps<Volume, IPlayerStores>): boolean {
        const {value: prevValue} = this.props;
        const {value: nextValue} = nextProps;

        return (
            prevValue.canShowLowVolumeBar !== nextValue.canShowLowVolumeBar ||
            prevValue.canShowMediumVolumeBar !== nextValue.canShowMediumVolumeBar ||
            prevValue.canShowHighVolumeBar !== nextValue.canShowHighVolumeBar
        );
    }

    public render(): JSX.Element {
        const {value} = this.props;

        return (
            <svg viewBox="0 0 100 100" className={styles.svgShadow}>
                <polygon points="49.115,23.473 49.115,76.527 28.518,61.547 13.538,61.547 13.538,38.453 28.518,38.453"/>
                {value.canShowLowVolumeBar &&
                    <polygon points="58.669,59.067 64.297,59.067 64.297,40.933 58.669,40.933"/>
                }
                {value.canShowMediumVolumeBar &&
                    <polygon points="70.55,67.822 76.178,67.822 76.178,32.178 70.55,32.178"/>
                }
                {value.canShowHighVolumeBar &&
                    <polygon points="82.432,76.577 88.06,76.577 88.06,23.423 82.432,23.423"/>
                }
            </svg>
        );
    }
}

export default connect(StoreName.VOLUME)(IconVolume);
